import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Navigation.css';
import logo from "../assests/Accountaxation-Services-Logo-12.ico";

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const getActiveClass = ({ isActive }) => (isActive ? 'active' : '');

  return (
    <header>
      <div className="top-bar">
        <div className="container">
          <div className="contact-info-nav">
            <a href="tel:+919016048820">+91 9016048820</a>
            <a href="mailto:servicesa783@gmail.com">servicesa783@gmail.com</a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="main-nav">
        <div className="container nav-container">
          {/* Logo */}
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src={logo} alt="Accountaxation Services Logo" style={{ height: '90px' }} />
          </Link>

          {/* Mobile Menu Toggle */}
          <div className="menu-icon" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </div>

          {/* Navigation Links */}
          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <ul className="main-menu">
              <li><NavLink to="/" className={getActiveClass} end onClick={closeMenu}>Home</NavLink></li>
              <li><NavLink to="/about" className={getActiveClass} onClick={closeMenu}>About Us</NavLink></li>

              {/* Services Dropdown */}
              <li className="services-dropdown">
                <HashLink smooth to="/#services-section" className={getActiveClass} onClick={closeMenu}>
                  Services
                </HashLink>
                <ul className="submenu">
                  <li><Link to="/services/registration" onClick={closeMenu}>Registration</Link></li>
                  <li><Link to="/services/taxation" onClick={closeMenu}>Taxation</Link></li>
                  <li><Link to="/services/accounting" onClick={closeMenu}>Accounting</Link></li>
                  <li><Link to="/services/epf" onClick={closeMenu}>EPF Services</Link></li>
                </ul>
              </li>
              <li><NavLink to="/contact" className={getActiveClass} onClick={closeMenu}>Contact</NavLink></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navigation;
